/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_Duration_HoursInputs */

const en_admin_resource_form_duration_hours = /** @type {(inputs: Admin_Resource_Form_Duration_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duration (hours)`)
};

const de_admin_resource_form_duration_hours = /** @type {(inputs: Admin_Resource_Form_Duration_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dauer (Stunden)`)
};

const es_admin_resource_form_duration_hours = /** @type {(inputs: Admin_Resource_Form_Duration_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duración (horas)`)
};

const fr_admin_resource_form_duration_hours = /** @type {(inputs: Admin_Resource_Form_Duration_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durée (heures)`)
};

/** @type {(inputs: Admin_Resource_Form_Duration_HoursInputs) => LocalizedString} */
const it_admin_resource_form_duration_hours = en_admin_resource_form_duration_hours;

/** @type {(inputs: Admin_Resource_Form_Duration_HoursInputs) => LocalizedString} */
const pt_br2_admin_resource_form_duration_hours = en_admin_resource_form_duration_hours;

/** @type {(inputs: Admin_Resource_Form_Duration_HoursInputs) => LocalizedString} */
const pl_admin_resource_form_duration_hours = en_admin_resource_form_duration_hours;

/** @type {(inputs: Admin_Resource_Form_Duration_HoursInputs) => LocalizedString} */
const hu_admin_resource_form_duration_hours = en_admin_resource_form_duration_hours;

/** @type {(inputs: Admin_Resource_Form_Duration_HoursInputs) => LocalizedString} */
const ro_admin_resource_form_duration_hours = en_admin_resource_form_duration_hours;

/**
* | output |
* | --- |
* | "Duration (hours)" |
*
* @param {Admin_Resource_Form_Duration_HoursInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_duration_hours = /** @type {((inputs?: Admin_Resource_Form_Duration_HoursInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_Duration_HoursInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_duration_hours(inputs)
	if (locale === "de") return de_admin_resource_form_duration_hours(inputs)
	if (locale === "es") return es_admin_resource_form_duration_hours(inputs)
	if (locale === "fr") return fr_admin_resource_form_duration_hours(inputs)
	if (locale === "it") return it_admin_resource_form_duration_hours(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_duration_hours(inputs)
	if (locale === "pl") return pl_admin_resource_form_duration_hours(inputs)
	if (locale === "hu") return hu_admin_resource_form_duration_hours(inputs)
	return ro_admin_resource_form_duration_hours(inputs)
});
export { admin_resource_form_duration_hours as "admin.resource_form.duration_hours" }